export { default } from './SideMenuFooterLink';
